import React from "react";
import { Interrogator, QuestionsObj } from "ewoq/containers/Interrogator";
import questions from "./Questions/PainSensitivityQuestions";
import { answerQuestionnaire } from "ewoq/api";

interface Props {
  viewAll?: boolean;
  onDone?: () => void;
}

class PainSensitivity extends React.Component<Props> {
  onSubmit = (answers: QuestionsObj) => {
    answerQuestionnaire("BIO", "Lifestyle-PainSensitivity", {
      answers: answers
    });
    this.props.onDone && this.props.onDone();
  };

  render() {
    return (
      <div>
        <Interrogator
          questions={questions}
          onDone={this.onSubmit}
          viewAll={this.props.viewAll}
        />
      </div>
    );
  }
}

export default PainSensitivity;
